module.exports = __webpack_public_path__ + "img/index_banner1.e5e2326b.jpg";